module.exports = __webpack_public_path__ + "img/illustration_arab.2548bd51.png";